import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/14.png';
import _imports_1 from '../../../assets/new/52.png';
import _imports_2 from '../../../assets/new/15.png';
const _withScopeId = n => (_pushScopeId("data-v-c8fd62fe"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "学乐智能阅读", -1));
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
  class: "link"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "agreement"
}, [/*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("注册即表示同意"), /*#__PURE__*/_createElementVNode("a", {
  href: "javascript: void(0)"
}, "《用户隐私协议》")])], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "2rem"
  }
}, null, -1));
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getLocalPid } from "../../../libs/util";
import { userRegister } from "../../../api/index";
import { ElMessage } from "element-plus";
export default {
  __name: 'register_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const router = useRouter();
    const disabled = ref(false);
    const username = ref("");
    const password = ref("");
    const phone = ref("");
    const nickname = ref("");
    const toRegister = () => {
      let obj = {
        pid: getLocalPid(),
        username: username.value,
        password: password.value,
        mobile: phone.value,
        nickname: nickname.value
      };
      disabled.value = true;
      userRegister(encodeURIComponent(JSON.stringify(obj))).then(res => {
        let data = res.data;
        disabled.value = false;
        console.log(data);
        if (data.code === 0) {
          localStorage.setItem("ways", "login");
          // 把token保存到本地
          let msg = JSON.stringify(data.data);
          // userMes中有userId和token
          localStorage.setItem("userMes", msg);
          localStorage.setItem("ways", "username");
          ElMessage.success("注册成功");
          store.commit("login", data.data);
          router.push({
            name: "schoolMes",
            query: {
              type: 123
            }
          });
        } else {
          ElMessage.error(data.msg);
        }
      }).catch(() => {
        disabled.value = false;
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_hoisted_3, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请输入用户名",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => username.value = $event)
      }, null, 512), [[_vModelText, username.value]])]), _createElementVNode("div", null, [_hoisted_4, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请输入姓名",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => nickname.value = $event)
      }, null, 512), [[_vModelText, nickname.value]])]), _createElementVNode("div", null, [_hoisted_5, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请输入手机号码",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => phone.value = $event)
      }, null, 512), [[_vModelText, phone.value]])]), _createElementVNode("div", null, [_hoisted_6, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请设置您的密码",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => password.value = $event)
      }, null, 512), [[_vModelText, password.value]])]), _createElementVNode("button", {
        type: "button",
        onClick: toRegister,
        disabled: disabled.value
      }, " 立即注册 ", 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, [_createTextVNode("已有账号，"), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'home'
        }))
      }, "直接登陆")])]), _hoisted_9]), _hoisted_10])], 2);
    };
  }
};